
<div class="file-upload-container">
  <span (click)="onDocumentIdClick()">
    {{ splitItem.documentName }}
  </span>
  <input #fileSelector type="file" class="custom-file-input" (change)="onFileSelected($event)" />
  <button *ngIf="!splitItem.documentName && splitItem.caseId && !isApproved" class="custom-upload-button" (click)="onUpload()">
    <img src="/assets/icons/add-new.svg" alt="Add pdf to split item" title="Add file"/>
  </button>
  <button *ngIf="splitItem.documentName && !isApproved" class="custom-delete-button" (click)="onDelete()">
    <img src="/assets/icons/remove.svg" alt="Remove pdf from split item" title="Remove file"/>
  </button>

</div>
